import historyTabTemplate from '@/audit/layout/historyTabTemplate';

export default historyTabTemplate(['datasets'], ({ datasets }) => datasets.audit, 'dataset');
